'use client'

import {
    MaterialDesignContent,
    SnackbarKey,
    SnackbarMessage,
    OptionsObject as SnackbarOptionsObject,
    SnackbarProviderProps,
} from 'notistack'
export { SnackbarProvider, useSnackbar } from 'notistack'

export const StyledErrorSnackbar = MaterialDesignContent

export const snackbarProviderDefaults: Omit<SnackbarProviderProps, 'children'> = {
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center',
    },
    variant: 'success',
    autoHideDuration: 3000,
    hideIconVariant: true,
}

export type EnqueueSnackbar = (message: SnackbarMessage, options?: SnackbarOptionsObject | undefined) => SnackbarKey
export type { SnackbarMessage, SnackbarOptionsObject }
export type Snackbar = [SnackbarMessage, SnackbarOptionsObject | undefined]
